// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"2b1c68ed","667":"039793ec"}[chunkId] + ".chunk.js";
};